import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useRef } from 'react';
import { generateFileThunk, useAppDispatch, useCommunicationContext, useScrollContext } from "../../../../../shared/model";
import { addMessage, updateMessageStatus } from "../../../../../entities/message/model";
import { MessageStatus, MessageType, createHistoryMessage } from "../../../../../shared/api";
import { FileSize } from "../../../../../shared/lib";
import { useNotificationContext } from "../../../../../entities/notification/model";
import { addQuickReplies } from "../../../../../entities/content/model";
export var useFileLoad = function useFileLoad() {
  var dispatch = useAppDispatch();
  var _useNotificationConte = useNotificationContext(),
    addNotification = _useNotificationConte.addNotification;
  var fileRef = useRef(null);
  var _useCommunicationCont = useCommunicationContext(),
    sendFileMessage = _useCommunicationCont.sendFileMessage;
  var _useScrollContext = useScrollContext(),
    scrollToBottom = _useScrollContext.scrollToBottom;
  var handleFileLoad = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _fileRef$current;
      var fileList, file, fileUrl, formData, historyMessage, data;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            // Загруженный файл
            fileList = (_fileRef$current = fileRef.current) === null || _fileRef$current === void 0 ? void 0 : _fileRef$current.files;
            if (!fileList) {
              _context.next = 23;
              break;
            }
            file = fileList[0];
            if (!(file.size > FileSize['5Mb'])) {
              _context.next = 6;
              break;
            }
            addNotification({
              key: 'bigSize',
              label: 'большой размер файла',
              subTitle: 'попробуйте загрузить другой',
              view: 'error'
            });
            return _context.abrupt("return");
          case 6:
            // URL загруженного файла
            fileUrl = URL.createObjectURL(file);
            formData = new FormData();
            formData.append('file', file);

            // Добавляем файл в историю со статусом MessageStatus.sent
            historyMessage = createHistoryMessage('', {
              status: MessageStatus.sent,
              messageType: MessageType.FileDoc
            }, {
              fileInfo: {
                fileUrl: fileUrl,
                name: file.name,
                size: file.size
              }
            });
            dispatch(addQuickReplies([]));
            dispatch(addMessage(historyMessage));

            // Скролл вниз при добавлении файла в историю
            scrollToBottom(0);
            _context.prev = 13;
            _context.next = 16;
            return dispatch(generateFileThunk(formData));
          case 16:
            data = _context.sent;
            // Отправка fileId в WS
            if (data.payload.id) {
              sendFileMessage(data.payload.id, historyMessage);
            }
            _context.next = 23;
            break;
          case 20:
            _context.prev = 20;
            _context.t0 = _context["catch"](13);
            dispatch(updateMessageStatus({
              id: historyMessage.messageId,
              status: MessageStatus.failed
            }));
          case 23:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[13, 20]]);
    }));
    return function handleFileLoad() {
      return _ref.apply(this, arguments);
    };
  }();
  return {
    fileRef: fileRef,
    handleFileLoad: handleFileLoad
  };
};